/**
 * Ex: 2023-04-03 00:00:00.000 => 03/04/2023
 * @param value
 * @returns
 */
export const dateFormat = (value: string) => {
  if (!value) return '';

  const date = new Date(value);
  const timezoneOffset = date.getTimezoneOffset() * 60000;
  const dateWithoutTimezone = new Date(date.getTime() + timezoneOffset);

  return dateWithoutTimezone.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};
/**
 * Ex: 2023-04-03 00:00:00.000 => 03/04/2023 00:00
 * @param value
 * @returns
 */
export const dateHoursFormat = (value: string) => {
  if (!value) return '';

  const date = new Date(value);
  const timezoneOffset = date.getTimezoneOffset() * 60000;
  const dateWithoutTimezone = new Date(date.getTime() + timezoneOffset);

  return dateWithoutTimezone
    .toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    })
    .replace(',', '');
};

export const formatDateWithTimeUTC = (value: string) => {
  if (!value) return '';

  const formatDate = value.replace('Z', '').replace('T', ' ');
  const date = new Date(formatDate);
  const timezoneOffset = date.getTimezoneOffset() * 60000;
  const dateWithoutTimezone = new Date(date.getTime() + timezoneOffset);

  return dateWithoutTimezone
    .toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
    .replace(',', '');
};
